export default __webpack_public_path__ + "static/media/cardDeveloper.58dcce63.svg";